import __request__ from 'routing/request';
interface InputTypeInfo {
    readonly requested_configuration: {
        readonly [_key: string]: {
            readonly [_key: string]: Object;
        };
    };
    readonly link_to_docs: string;
    readonly name: string;
    readonly is_exclusive: boolean;
    readonly type: string;
}
interface InputTypeInfoMap {
    readonly [_key: string]: InputTypeInfo;
}
interface InputTypesSummaryResponse {
    readonly types: {
        readonly [_key: string]: string;
    };
}
/**
 * Get all available input types.
 */
export function types(): Promise<InputTypesSummaryResponse> {
    return __request__('GET', '/plugins/org.graylog.plugins.forwarder/forwarder/inputs/types', null, {}, {
        'Accept': ['application/json']
    });
}
/**
 * Get information about all input types
 */
export function all(): Promise<InputTypeInfoMap> {
    return __request__('GET', '/plugins/org.graylog.plugins.forwarder/forwarder/inputs/types/all', null, {}, {
        'Accept': ['application/json']
    });
}
/**
 * Get information about a single input type
 */
export function info(inputType: string): Promise<InputTypeInfo> {
    return __request__('GET', `/plugins/org.graylog.plugins.forwarder/forwarder/inputs/types/${inputType}`, null, {}, {
        'Accept': ['application/json']
    });
}
